import { useCallback } from 'react';

const INCLUDE_DRAFTS = { includeDrafts: 'true' };

/**
 * A list's fetch, or its count's, asking for the drafts its reader sees as well. Wrap the list's own trigger only:
 * the pickers reading the same endpoint must stay draft-free.
 */
export function useWithDrafts<A extends { extraParams?: Record<string, string> }, R>(
    trigger: (arg: A, preferCacheValue?: boolean) => R
): (arg: A, preferCacheValue?: boolean) => R {
    return useCallback(
        (arg: A, preferCacheValue?: boolean) =>
            trigger({ ...arg, extraParams: { ...arg.extraParams, ...INCLUDE_DRAFTS } }, preferCacheValue),
        [trigger]
    );
}
